<template>
  <!-- https://github.com/valgeirb/vue3-popper/issues/56 -->
  <!-- <ClientOnly> -->
    <popper
      placement="top"
      hover
    >
      <template #content>
        <div class="popper">
          <slot />
        </div>
      </template>

      <button slot="reference" class="p-0">
        <!-- circled question mark svg -->
        <img loading="lazy" src="~/assets/img/ico-help.svg" width="20" alt="help" class="min-w-5">
      </button>
    </popper>
  <!-- </ClientOnly> -->
</template>

<script lang="ts">
// https://github.com/valgeirb/vue3-popper/issues/56
import Popper from 'vue3-popper/dist/popper.esm'

export default defineNuxtComponent({
  components: {
    'popper': Popper
  },
})
</script>

<style scoped>
.popper {
  max-width: min(90vw, 512px);
  text-align: left;
  @apply font-normal;
}
</style>
